import { createLoadableList } from 'external/immutability-helper'
import create, {initializeAndRegisterHooks} from 'context/create' 
import hooks, * as resolves from './hooks'

const initialState = {
  events: [],
  eventCategories: [],
  refreshData: 0,
  eventsByDay: {},
  teachers: undefined,
  courses: undefined,
  assignments: undefined,
  assignedContent: undefined,
  gradesContent: undefined,
  gradesPageSize: 999,
  recentActivity: undefined,
  messages: createLoadableList(),
  messagesSources: ['teacher', 'institution', 'news'],
  messagesSource: 'teacher',
}

const id = 'Student'

const context = create(id, initialState, {onInit: initializeAndRegisterHooks(id, hooks, resolves)})

export {context as default}
